"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _arrow = _interopRequireDefault(require("@sfly/uig-svg-icon/action/arrow"));

var _categoryConfig = _interopRequireDefault(require("./../categoryConfig"));

var _parseCatalogData = _interopRequireDefault(require("./../common/util/parseCatalogData"));

var _photos = _interopRequireDefault(require("@sfly/uig-svg-icon/photos/photos"));

var _photos_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/photos/photos_selected"));

var _account = _interopRequireDefault(require("@sfly/uig-svg-icon/account/account"));

var _account_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/account/account_selected"));

var _myProjects_selected = _interopRequireDefault(require("@sfly/uig-svg-icon/my-projects/my-projects_selected"));

var _dropdown = _interopRequireDefault(require("@sfly/uig-svg-icon/action/dropdown"));

var _uigTooltipDropdownMenu = _interopRequireDefault(require("@sfly/uig-tooltip-dropdown-menu"));

var _myProjects = _interopRequireDefault(require("@sfly/uig-svg-icon/my-projects/my-projects"));

var _uigButton = require("@sfly/uig-button");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var _config = require("./../config");

var _constants = require("../constants");

var _SpoonFlowerHamBurger = _interopRequireDefault(require("../components/SpoonFlowerHamBurger"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _helperUtil = require("./../common/util/helperUtil");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var RESPONSIVE_SIGN_UP_URL = "https://www.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/signupconfirmation");

var HamburgerMenuComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(HamburgerMenuComponent, _React$Component);

  var _super = _createSuper2(HamburgerMenuComponent);

  function HamburgerMenuComponent(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, HamburgerMenuComponent);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (e) {
      e.nativeEvent.stopImmediatePropagation();

      _this.setState(function (prevState) {
        return {
          dropdownExpanded: !prevState.dropdownExpanded
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeDropDown", function (e) {
      e.nativeEvent.stopImmediatePropagation();

      _this.setState({
        dropdownExpanded: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onListItemClick", function (e) {
      if (!_this.state.dropdownExpanded) {
        var codeSelected = e.currentTarget.getAttribute('data-column');

        _this.setState({
          selectedCategory: codeSelected
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNewLabel", function (newCategoryTagEnabled) {
      return newCategoryTagEnabled ? _react.default.createElement("span", {
        className: 'uig-new-label'
      }, "NEW") : null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMenuItemKeyDown", function (e, isLastItem) {
      if (isLastItem && !e.shiftKey && e.keyCode === 9) {
        if (_this.hamburgerButton) {
          e.preventDefault();

          _this.hamburgerButton.focus();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "listItem", function (categoryItem, index, items, isFirstLevelCat) {
      var categoryClassName = 'uig-hbm-category-item ';
      var arrowClassName = 'uig-hbm-icon-span';
      var props = {
        id: categoryItem.code + categoryItem.name,
        key: categoryItem.code + categoryItem.name,
        className: categoryClassName,
        'data-column': categoryItem.code
      };
      var isLastItem = items.length - 1 === index;
      var isFirstItem = index === 0;
      var linkProps = {};

      if (!isFirstLevelCat && isFirstItem) {
        linkProps.ref = _this.firstMenuItemRef;
      }

      ;

      if (!categoryItem.hasSubCategories) {
        return _react.default.createElement("li", (0, _extends2.default)({}, props, {
          key: categoryItem.code + categoryItem.name,
          onKeyDown: function onKeyDown(e) {
            _this.onMenuItemKeyDown(e, isLastItem);
          }
        }), _react.default.createElement("a", (0, _extends2.default)({
          rel: (0, _helperUtil.getFollowOrNoFollow)(_this.state.activeStore),
          href: (0, _helperUtil.getDomainUrl)(_this.state.activeStore) + categoryItem.url,
          role: 'menuitem'
        }, (0, _config.getLinkTrackingAttr)(categoryItem.mobileName || categoryItem.name, 'global-header', 'mobile-side-menu', 'none', index), linkProps), (0, _helperUtil.getPlainText)(categoryItem.mobileName || categoryItem.name), _this.renderNewLabel(categoryItem.newCategoryTagEnabled)));
      }

      props.onClick = _this.onListItemClick;
      return _react.default.createElement("li", (0, _extends2.default)({
        tabIndex: 0,
        key: categoryItem.code + categoryItem.name,
        "aria-label": categoryItem.mobileName || categoryItem.name,
        role: 'menuitem',
        "aria-haspopup": "true",
        "aria-expanded": _this.state.selectedCategory === categoryItem.code,
        onKeyDown: function onKeyDown(event) {
          _this.onMenuItemKeyDown(event, isLastItem);

          (0, _helperUtil.handleKeyPress)(event, function () {
            _this.onListItemClick(event);
          });
        }
      }, props), (0, _helperUtil.getPlainText)(categoryItem.mobileName || categoryItem.name), _this.renderNewLabel(categoryItem.newCategoryTagEnabled), _react.default.createElement("span", {
        className: arrowClassName
      }, _react.default.createElement(_arrow.default, null)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownOptions", function () {
      var buttonOptions = [],
          loggedIn = !!_this.props.userFirstName || !!_this.state.jwtToken;

      if (!loggedIn) {
        buttonOptions.push(_react.default.createElement("div", {
          className: "sign-in-up-buttons",
          key: "sign-in-up-buttons"
        }, _react.default.createElement("li", {
          key: "signin-button"
        }, _react.default.createElement(_uigButton.PrimaryButton, (0, _extends2.default)({
          "aria-label": "Sign In",
          role: 'button',
          tabIndex: 0,
          className: 'button-initial-appearance',
          onKeyDown: function onKeyDown(event) {
            return (0, _helperUtil.handleKeyPress)(event, function () {
              _this.handleSigninClick(event);
            });
          }
        }, (0, _config.getLinkTrackingAttr)('sign-in', 'global-header', 'mobile-side-menu', 'none', '0'), {
          onClick: _this.handleSigninClick
        }), "Sign In")), _react.default.createElement("li", {
          key: "signup-button"
        }, _react.default.createElement(_uigButton.SecondaryButton, (0, _extends2.default)({
          "aria-label": "Sign Up",
          role: 'button',
          className: 'button-initial-appearance',
          tabIndex: 0,
          onKeyDown: function onKeyDown(event) {
            return (0, _helperUtil.handleKeyPress)(event, function () {
              _this.handleSignupClick(event);
            });
          }
        }, (0, _config.getLinkTrackingAttr)('sign-up', 'global-header', 'mobile-side-menu', 'none', '1'), {
          onClick: _this.handleSignupClick
        }), "Sign Up"))));
      }

      var userMenuOptions = (0, _config.getUserMenuOptions)(_this.state.activeStore);
      var options = userMenuOptions.map(function (option, index) {
        if (option.hidden) {
          return null;
        }

        var menuName = option.text;

        if (option.key === 'my-projects' && _this.props.projectCnt > 0) {
          menuName = option.text + '(' + _this.props.projectCnt + ')';
        }

        return _react.default.createElement("li", {
          key: option.key
        }, _react.default.createElement("a", (0, _extends2.default)({
          href: "".concat((0, _helperUtil.getDomainUrl)('SFLY')).concat(option.url),
          onClick: function onClick(event) {
            _this.handleSecuredLinksClick(event);

            _this.toggleDropdown(event);
          }
        }, option.attr, {
          onKeyDown: function onKeyDown(e) {
            if (!loggedIn && index === userMenuOptions.length - 1 && !e.shiftKey && _Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.tab])) {
              _this.toggleDropdown(e);
            }
          }
        }), menuName));
      });

      if (_this.props.extraDropdownOptions && _this.props.extraDropdownOptions.length > 0) {
        options.push(_react.default.createElement("li", {
          className: "divider",
          key: "extra-divider"
        }));

        for (var index in _this.props.extraDropdownOptions) {
          var option = _this.props.extraDropdownOptions[index];
          var position = (0, _parseInt2.default)(index) + userMenuOptions.length;
          options.push(_react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", (0, _extends2.default)({
            href: option.url,
            onClick: _this.toggleDropdown
          }, option.attrs, (0, _config.getLinkTrackingAttr)(option.text, 'global-header', 'mobile-side-menu', 'none', position)), option.text)));
        }
      }

      if (loggedIn) {
        var _position = userMenuOptions.length;

        if (_this.props.extraDropdownOptions && _this.props.extraDropdownOptions.length) {
          _position = _position + _this.props.extraDropdownOptions.length;
        }

        options.push(_react.default.createElement("li", {
          className: "divider",
          key: "signout-divider"
        }));
        options.push(_react.default.createElement("li", {
          key: "sign-out"
        }, _react.default.createElement("a", (0, _extends2.default)({
          href: "".concat((0, _helperUtil.getDomainUrl)('SFLY'), "/signout/start.sfly?brand=").concat(_this.props.brandType, "&logout=true")
        }, (0, _config.getLinkTrackingAttr)('sign-out', 'global-header', 'mobile-side-menu', 'none', _position), {
          onKeyDown: function onKeyDown(e) {
            if (!e.shiftKey && _Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.tab])) {
              _this.toggleDropdown(e);
            }
          }
        }), "Sign out")));
      }

      return [].concat(buttonOptions, (0, _toConsumableArray2.default)(options));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMyAccountLink", function () {
      var dropdownExpanded = _this.state.dropdownExpanded;
      var name = 'Sign In';

      if (!!_this.props.userFirstName || _this.state.user) {
        name = "Hi, ".concat(_this.props.userFirstName || _this.state.user.given_name || 'Guest');
      }

      return _react.default.createElement("span", {
        className: "uig-menu-item uig-myAccount-link",
        onMouseEnter: function onMouseEnter(event) {
          _this.handleIconMouseEvents(event, 'AccountIcon');
        },
        onMouseLeave: function onMouseLeave(event) {
          _this.handleIconMouseEvents(event, 'AccountIcon');
        }
      }, _react.default.createElement("a", (0, _extends2.default)({
        onClick: _this.toggleDropdown,
        tabIndex: 0,
        role: 'menuitem',
        "aria-label": name,
        "aria-haspopup": "true",
        "aria-expanded": dropdownExpanded,
        onKeyDown: function onKeyDown(event) {
          if (_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.enter, _Utils.default.keyCodeMap.space]) || _this.state.dropdownExpanded && event.shiftKey && !_Utils.default.filterKeyPress(event, [_Utils.default.keyCodeMap.tab])) {
            _this.toggleDropdown(event);
          }
        }
      }, (0, _config.getLinkTrackingAttr)('sign-in-user', 'global-header', 'mobile-side-menu', 'none', '0')), _this.state.iconsMouseOverState.AccountIcon || _this.state.dropdownExpanded ? _react.default.createElement(_account_selected.default, {
        className: "accountIcon-svg"
      }) : _react.default.createElement(_account.default, {
        className: "accountIcon-svg"
      }), _react.default.createElement("span", {
        className: "uig-hbm-toolbar-menu-label"
      }, name), _react.default.createElement(_dropdown.default, {
        className: "accountIcon-svg ".concat(_this.state.dropdownExpanded ? 'uig-expanded' : 'uig-collapse')
      })), _this.state.dropdownExpanded ? _this.loggedInDropdown() : '');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSignupLink", function () {
      return _react.default.createElement("span", {
        className: "uig-menu-item uig-myAccount-link"
      }, _react.default.createElement("a", (0, _extends2.default)({
        onClick: _this.handleSigninClick,
        tabIndex: 0,
        role: 'menuitem',
        "aria-label": 'Sign in',
        onKeyDown: function onKeyDown(event) {
          return (0, _helperUtil.handleKeyPress)(event, function () {
            _this.handleSigninClick(event);
          });
        }
      }, (0, _config.getLinkTrackingAttr)('sign-in', 'global-header', 'mobile-side-menu', 'none', '0')), _react.default.createElement(_account.default, {
        className: "accountIcon-svg"
      }), _react.default.createElement("span", {
        className: "uig-hbm-toolbar-menu-label"
      }, "Sign In")));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMyPhotosLink", function () {
      return _react.default.createElement("span", {
        className: "uig-menu-item uig-myPhotos",
        onMouseEnter: function onMouseEnter(event) {
          _this.handleIconMouseEvents(event, 'PhotosIcon');
        },
        onMouseLeave: function onMouseLeave(event) {
          _this.handleIconMouseEvents(event, 'PhotosIcon');
        }
      }, _react.default.createElement("a", (0, _extends2.default)({
        title: "View, organize and edit your photos.",
        className: "myphotoLink",
        href: "https://photos.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/?brand=").concat(_this.props.brandType),
        onClick: _this.handleSecuredLinksClick
      }, (0, _config.getLinkTrackingAttr)('photos', 'global-header', 'mobile-side-menu', 'none', '1'), {
        tabIndex: "0"
      }), _this.state.iconsMouseOverState.PhotosIcon ? _react.default.createElement(_photos_selected.default, {
        className: "accountIcon-svg"
      }) : _react.default.createElement(_photos.default, {
        className: "accountIcon-svg"
      }), _react.default.createElement("span", {
        className: "uig-hbm-toolbar-menu-label"
      }, "Photos")));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMyProjectsLink", function () {
      return _react.default.createElement("span", {
        className: "uig-menu-item uig-myProjects",
        onMouseEnter: function onMouseEnter(event) {
          _this.handleIconMouseEvents(event, 'ProjectsIcon');
        },
        onMouseLeave: function onMouseLeave(event) {
          _this.handleIconMouseEvents(event, 'ProjectsIcon');
        }
      }, _react.default.createElement("a", (0, _extends2.default)({
        title: "View, organize and edit your projects.",
        className: "myProjectsLink",
        href: "https://www.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/mySavedProjects/"),
        onClick: _this.handleSecuredLinksClick,
        "data-linkname": "mWeb | My Projects"
      }, (0, _config.getLinkTrackingAttr)('mWeb | My Projects', 'global-header', 'mobile-side-menu', 'none', '2'), {
        tabIndex: "0"
      }), _this.state.iconsMouseOverState.ProjectsIcon ? _react.default.createElement(_myProjects_selected.default, {
        className: "projectIcon-svg"
      }) : _react.default.createElement(_myProjects.default, {
        className: "projectIcon-svg"
      }), _react.default.createElement("span", {
        className: "uig-hbm-toolbar-menu-label"
      }, "Projects")));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderOptionsMenu", function () {
      return _react.default.createElement("div", {
        className: 'uig-hbm-toolbar-menu'
      }, _this.renderMyAccountLink(), _this.renderMyPhotosLink(), _this.renderMyProjectsLink());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCategoriesMenu", function () {
      if (!_this.state.categories) return _react.default.createElement("div", null);
      var selectedCategory = _this.state.selectedCategory;
      var category = _this.state.categories[selectedCategory];

      if (!category) {
        return null;
      }

      var isBackVisible = category && category.code !== _categoryConfig.default.HOME_ID;
      var menuTitleClass = !isBackVisible ? 'uig-hbm-menu-title' : 'uig-hbm-menu-title uig-hbm-not-home';
      var categoryClass = "".concat(_this.state.dropdownExpanded ? 'grayout' : '', " ").concat(!isBackVisible ? 'uig-hbm-categories' : 'uig-hbm-categories uig-hbm-not-home');
      return _react.default.createElement("div", {
        className: "uig-humburger-menu-wrapper-container ".concat(_this.state.dropdownExpanded ? 'grayout' : '')
      }, isBackVisible && category.parentCategory && _react.default.createElement("div", {
        className: "uig-hbm-back",
        "data-column": category.parentCategory.code,
        tabIndex: 0,
        role: 'menuitem',
        "aria-label": "See All ".concat(category.parentCategory.name) //role={'alert'}
        ,
        onKeyDown: function onKeyDown(event) {
          return (0, _helperUtil.handleKeyPress)(event, function () {
            _this.onListItemClick(event);
          });
        },
        onClick: _this.onListItemClick
      }, _react.default.createElement(_arrow.default, {
        className: "uig-hbm-back-arrow"
      }), "See All ".concat(category.parentCategory.name)), category && category.code !== '0_-1' ? _react.default.createElement("div", {
        className: menuTitleClass
      }, category.mobileName || category.name) : '', _react.default.createElement("ul", {
        className: categoryClass,
        onClick: _this.closeDropDown
      }, category.subCategoriesList && category.subCategoriesList.map(function (categoryItem, index) {
        return _this.listItem(categoryItem, index, category.subCategoriesList, category && category.code === '0_-1');
      }), (0, _isArray.default)(category) && category.map(function (categoryItem, index) {
        return _this.listItem(categoryItem, index, category);
      })));
    });
    _this.state = {
      activeStore: _props.brandType,
      selectedCategory: _categoryConfig.default.HOME_ID,
      categories: null,
      dropdownExpanded: false,
      iconsMouseOverState: {
        AccountIcon: false,
        PhotosIcon: false,
        ProjectsIcon: false
      }
    };
    _this.handleSigninClick = _this.handleSigninClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSignupClick = _this.handleSignupClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSecuredLinksClick = _this.handleSecuredLinksClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeDropDown = _this.closeDropDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.firstMenuItemRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(HamburgerMenuComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var categoryCache = this.props.categoryCache;
      this.hamburgerButton = typeof document !== 'undefined' && document.querySelector('.uig-responsive-header-menu');
      categoryCache && categoryCache.listenToCatalog(function (categories) {
        categories = (0, _parseCatalogData.default)(categories, _this2.props.brandType);

        _this2.setState({
          categories: categories
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.selectedCategory !== prevState.selectedCategory && this.firstMenuItemRef && this.firstMenuItemRef.current) {
        this.firstMenuItemRef.current.focus();
      }
    }
  }, {
    key: "handleIconMouseEvents",
    value: function handleIconMouseEvents(event, iconName) {
      event.preventDefault();

      if (event.type === 'mouseenter' && !this.state.iconsMouseOverState[iconName]) {
        this.setState(function (currentState) {
          return currentState.iconsMouseOverState[iconName] = true;
        });
      } else if (event.type === 'mouseleave' && this.state.iconsMouseOverState[iconName]) {
        this.setState(function (currentState) {
          return currentState.iconsMouseOverState[iconName] = false;
        });
      }
    }
  }, {
    key: "handleSigninClick",
    value: function handleSigninClick(evt) {
      evt.preventDefault();
      var signinForwardUrl = this.props.signinForwardUrl;
      this.directToSflyAuth(signinForwardUrl);
    }
  }, {
    key: "handleSignupClick",
    value: function handleSignupClick(evt) {
      evt.preventDefault();
      var signupForwardUrl = this.props.signupForwardUrl;
      var params = (0, _helperUtil.getQueryStringParameters)(typeof window !== 'undefined' ? window.location.href : '');
      var ssoPayload = {
        redirectUri: signupForwardUrl,
        brand: this.props.brandType,
        ssoAction: true,
        cid: params.CID || params.cid || ''
      };

      if (typeof window !== 'undefined' && window.$sflyAuth) {
        window.$sflyAuth.showSignUp(ssoPayload);
      }
    }
  }, {
    key: "handleSecuredLinksClick",
    value: function handleSecuredLinksClick(evt) {
      evt.preventDefault();
      var targetUrl = evt.currentTarget.href;

      if (typeof window !== 'undefined') {
        if (window.$sflyAuth && !this.state.jwtToken) {
          this.directToSflyAuth(targetUrl);
        } else {
          window.location.href = targetUrl;
        }
      }
    }
  }, {
    key: "directToSflyAuth",
    value: function directToSflyAuth(redirectUri) {
      var params = (0, _helperUtil.getQueryStringParameters)(typeof window !== 'undefined' ? window.location.href : '');
      var ssoPayload = {
        redirectUri: redirectUri,
        brand: this.props.brandType,
        cid: params.CID || params.cid || ''
      };

      if (typeof window !== 'undefined' && window.$sflyAuth) {
        window.$sflyAuth.showSignIn(ssoPayload);
      }
    }
  }, {
    key: "loggedInDropdown",
    value: function loggedInDropdown() {
      return _react.default.createElement(_uigTooltipDropdownMenu.default, {
        className: "uig-dropdown-menu",
        anchorRight: true
      }, _react.default.createElement("ul", {
        className: "logged-in-dropdown-list",
        onClick: function onClick(e) {
          return e.nativeEvent.stopImmediatePropagation();
        }
      }, this.dropdownOptions()));
    }
  }, {
    key: "render",
    value: function render() {
      var isSpoonflowerDayOneEnabled = this.props.isSpoonflowerDayOneEnabled;
      console.log(' Inside render : projectCnt : ', this.props.projectCnt);
      var menuClassName = "uig-hamburger-menus ".concat(this.props.menuStatus, " ").concat(this.props.brandType === _constants.BRANDS.TINYPRINTS ? 'TP' : '');
      var menuBackdrop = "uig-hamburger-menu-backdrop ".concat(this.props.menuStatus);
      return _react.default.createElement("div", {
        className: menuClassName
      }, this.renderOptionsMenu(), isSpoonflowerDayOneEnabled && _react.default.createElement(_SpoonFlowerHamBurger.default, null), this.renderCategoriesMenu());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, state) {
      var user = _ref.user,
          jwtToken = _ref.jwtToken,
          brandType = _ref.brandType;
      return {
        user: user,
        jwtToken: jwtToken,
        activeStore: brandType
      };
    }
  }]);
  return HamburgerMenuComponent;
}(_react.default.Component);

exports.default = HamburgerMenuComponent;
HamburgerMenuComponent.propTypes = {
  menuStatus: _propTypes.default.string,
  extraDropdownOptions: _propTypes.default.array,
  categoryCache: _propTypes.default.object,
  user: _propTypes.default.object,
  brandType: _propTypes.default.oneOf([_constants.BRANDS.SHUTTERFLY, _constants.BRANDS.TINYPRINTS, _constants.BRANDS.INC]),
  signinForwardUrl: _propTypes.default.string,
  signupForwardUrl: _propTypes.default.string,
  isSpoonflowerDayOneEnabled: _propTypes.default.bool,
  userFirstName: _propTypes.default.string
}; //Todo : As of now hamburger signin/signup keep rediect to window.location.href not not myAccount

HamburgerMenuComponent.defaultProps = {
  menuStatus: false,
  brandType: _constants.BRANDS.SHUTTERFLY,
  extraDropdownOptions: null,
  user: typeof window !== 'undefined' ? window.$sflyAuth && window.$sflyAuth.currentUser : undefined,
  signinForwardUrl: typeof window !== 'undefined' ? window.location.href : '',
  signupForwardUrl: RESPONSIVE_SIGN_UP_URL,
  isSpoonflowerDayOneEnabled: false,
  userFirstName: ''
};